import SbgPrintable from "./SbgPrintable";
import { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import { useParams } from "react-router-dom";

const SbgPublic = ({ match }) => {
  let { hash } = useParams();
  const [data, setData] = useState(null);
  const [url, setUrl] = useState();
  const [loading, setLoading] = useState(false);
  const [isFullPrint, setIsFullPrint] = useState(false);

  useEffect(() => {
    getData();
    setUrl(
      window.location.pathname.slice(
        1,
        window.location.pathname.lastIndexOf("/")
      )
    );
  }, []);

  const getData = () => {
    setLoading(true);
    AxiosCustomGet(
      `${process.env.REACT_APP_BASE_API_URL}sbg/${hash}`,
      Config(),
      (response) => {
        setLoading(false);
        setData(response.data.data);
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title:
              error.response.data.error?.message ||
              "Whoops, something went wrong",
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const onPrint = async (isFullPrint) => {
    await setIsFullPrint(isFullPrint);
    window.print();
  };

  return (
    <div className="p-4 mx-auto">
      {!loading ? (
        data && (
          <div>
            {window.location.pathname.substring(
              window.location.pathname.lastIndexOf("/") + 1
            ) !== "customer" && (
              <>
                <button
                  className="btn btn-sm bgc-2C465C text-white mb-3"
                  onClick={() => onPrint(true)}
                >
                  Full Print
                </button>
                <button
                  className="btn btn-sm bgc-2C465C text-white mb-3 ml-2"
                  onClick={() => onPrint(false)}
                >
                  Pre-printed
                </button>
              </>
            )}
            <SbgPrintable
              isFullPrint={isFullPrint}
              data={data}
              valuator={url === "sbg-public-valuator" ? true : false}
            />
          </div>
        )
      ) : (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </div>
  );
};

export default SbgPublic;
